/** @jsx jsx */
import React from 'react';
import { Stack, Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import Skeleton from '@atlaskit/skeleton';

const styles = cssMap({
	container: {
		width: '458px',
	},
	topSection: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
	bottomSection: {
		width: '458px',
		height: '240px',
		borderBottomLeftRadius: token('radius.large'),
		borderBottomRightRadius: token('radius.large'),
		backgroundColor: token('color.skeleton'),
	},
});

export const InheritancePopupSkeleton = () => (
	<Box xcss={styles.container}>
		<Stack space="space.200" xcss={styles.topSection}>
			<Skeleton width="170px" height="24px" />
			<Stack space="space.150">
				<Skeleton width="426px" height="16px" />
				<Skeleton width="344px" height="16px" />
				<Skeleton width="152px" height="16px" />
			</Stack>
		</Stack>
		<Box xcss={styles.bottomSection} />
	</Box>
);
